import { createContext, useContext } from 'react';

import { RunPayrollSchemaContract } from 'schemas/RunPayrollSchema';

export const RunPayrollDataContext = createContext<RunPayrollSchemaContract | undefined>(undefined);

export const useRunPayrollDataContext = () => {
  return useContext(RunPayrollDataContext) as RunPayrollSchemaContract;
};
